import { PText } from "@porsche-design-system/components-react"
import { usePorscheApprovedWarrantyDurationText } from "../components/porscheApprovedSale/usePorscheApprovedWarrantyDurationText"

interface PorscheApprovedWarrantyDurationSaleActivityContainerProps {
	sale?: {
		warrantyDurationInMonths: number
		withAssistance: boolean
	}
}

export const PorscheApprovedWarrantyDurationSaleActivityContainer = ({
	sale,
}: PorscheApprovedWarrantyDurationSaleActivityContainerProps) => {
	const message = usePorscheApprovedWarrantyDurationText({ sale })

	return <PText>{message}</PText>
}
